import styles from '@/styles/About.module.css'
import Head from 'next/head'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import HomeImage from '/public/img/Home.webp'
import { useTranslation } from 'react-i18next'

const Sallad = dynamic(() => import('@/components/Sallad'))

const sallad = () => {
  const { t } = useTranslation()
  const generateMissingImage = (width, height, alt) => {
    if (
      !width ||
      !height ||
      typeof width !== 'number' ||
      typeof height !== 'number'
    ) {
      return (
        <Image
          src={HomeImage}
          className={styles.imageUrl}
          width={200}
          height={100}
          alt={alt || 'Image Not Available'}
          loading='lazy'
        />
      )
    }
    return (
      <Image
        src={`https://via.placeholder.com/${width}x${height}`}
        width={width}
        height={height}
        alt={alt || 'Image Not Available'}
        loading='lazy'
      />
    )
  }

  // Define your itemListElement array
  const itemList = [
    // Your item list here...
  ]

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Sallad Meny</title>
        <meta
          name='description'
          content='Denna livfulla sallad är packad med färska, hälsosamma ingredienser som säkerligen kommer att glädja din smak. [paprika, ägg, citron, räkor, avocado, isbergsalld, tomat och gurka. Dnena sallad är utmärkt källa till vitaminer, mineraler och fiber] Kombinationen av [salladen är en blandning av sötma, syra, salt och umami] samt skapar en smaksymfoni som är både uppfriskande och tillfredsställande'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemList.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                  '@type': 'Recipe',
                  name: item.name,
                  image: item.image,
                  description: item.description,
                  recipeIngredient: item.recipeIngredient,
                  offers: item.offers,
                  aggregateRating: item.aggregateRating,
                },
              })),
            }),
          }}
        ></script>
      </Head>
      <Sallad />
      {itemList.map((item, index) => (
        <div key={index}>
          {/* Render item details */}
          <h3>{item.name}</h3>
          <p>{item.description}</p>
          {/* Render image */}
          {typeof item.image === 'string' ? (
            <Image
              src={item.image}
              width={200}
              height={100}
              alt={item.name}
              loading='lazy'
            />
          ) : (
            generateMissingImage(200, 100, item.name)
          )}
        </div>
      ))}
    </main>
  )
}

export default sallad
